import React from "react";
import { animated, useSpring } from "react-spring";
import { localize, shorten } from "@backpacker/number";
import { Locale } from "@linkfluence/models/locale";

interface IProps {
  locale: Locale;
  value: number;
  short?: boolean;
}

const Count = ({ value, locale, short }: IProps) => {
  const animatedValues = useSpring({
    config: { duration: 500 },
    from: { total: 0 },
    to: { total: value },
  });
  return (
    <animated.div>
      {
        //@ts-ignore
        animatedValues.total.interpolate((x) =>
          short ? shorten(locale, x, 3) : localize(locale, x)
        )
      }
    </animated.div>
  );
};

export default Count;
